module.exports = "<div class=\"link--centered\">\n\t<a\n\t\t\tclass=\"link__text bodySmall\"\n\t\t\t[href]=\"linkUrl\"\n\t\t\ttarget=\"_blank\"\n\t\t>\n\t\t\t{{ linkText }}\n\t\t</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/components/link/link.component.html
// module id = ../../../../../src/app/shared/components/link/link.component.html
// module chunks = main